/**
 * Serviço centralizado para exibir alertas e mensagens
 * Gerencia modal-alert de forma global na aplicação
 */
class AlertService {
  constructor() {
    this.modalElement = null
    this._ensureModal()
  }

  _ensureModal() {
    if (!this.modalElement) {
      this.modalElement = document.createElement('modal-alert')
      document.body.appendChild(this.modalElement)
    }
  }

  show(message, title = '', type = 'info') {
    this._ensureModal()
    return new Promise((resolve) => {
      const handleClose = () => {
        this.modalElement.removeEventListener('modal-closed', handleClose)
        resolve()
      }
      
      this.modalElement.addEventListener('modal-closed', handleClose)
      this.modalElement.show(message, title, type)
    })
  }

  info(message, title = 'Informação') {
    return this.show(message, title, 'info')
  }

  warning(message, title = 'Atenção') {
    return this.show(message, title, 'warning')
  }

  error(message, title = 'Erro') {
    return this.show(message, title, 'error')
  }

  success(message, title = 'Sucesso') {
    return this.show(message, title, 'success')
  }
}

export const alertService = new AlertService()
